module.exports = __webpack_public_path__ + "static/media/sh_logo_full_vertical.3c4d6f75.png";